/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import msdyn365Commerce from '@msdyn365-commerce/core-internal';
import { ProductSearchResult } from '@msdyn365-commerce/retail-proxy';

export * from '@msdyn365-commerce/core-internal';
export { ITelemetry, LogLevel, TelemetryEvent, TelemetryEventContent } from '@msdyn365-commerce/telemetry-internal';
export {
    ActionContext,
    buildHydratedMockActionContext,
    createDataAction,
    createObservableDataAction,
    createDataActionHook,
    getCatalogName,
    getMediaLocationsForProductAction,
    MediaLocationsInput,
    MediaLocationType,
    getAdditionalMediaLocationsForProductAction,
    getCustomerActionDataAction,
    GetCustomerInput,
    createGetCustomerInput
} from '@msdyn365-commerce/action-internal';
export * from '@msdyn365-commerce/retail-proxy/dist/async-result';
export * from '@msdyn365-commerce/retail-proxy/dist/data-types';
// Workaround to export ProudctList type found in retail-proxy to add additional typed properties so that users dont have to
// update their retail-proxy to take advantage of these new typed properties
export interface IProductList {
    products: ProductSearchResult[];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    listMetadata: any;
    listType: string;
    recommendationListId: string;
    discountIds?: string[];
}

export default msdyn365Commerce;
